"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getProductById = exports.getMarketplaceCountryId = exports.getFilters = exports.getMarketplaceConvertedPrices = exports.getMarketplaceConvertedPrice = exports.getMarketplaceExchangeDenomination = exports.getMarketplaceExchangeIsLoading = exports.getMarketplaceIsLoading = exports.getCurrentMarketplacePage = exports.getProductsPagination = exports.getProducts = exports.getProduct = exports.getMarketplaceState = void 0;

var R = _interopRequireWildcard(require("ramda"));

var _reselect = require("reselect");

var getCreateGiftState = R.prop('createGift');
var getMarketplaceState = R.compose(R.prop('marketplace'), getCreateGiftState);
exports.getMarketplaceState = getMarketplaceState;
var getProduct = R.compose(R.prop('product'), getMarketplaceState);
exports.getProduct = getProduct;
var getProducts = R.compose(R.prop('products'), getMarketplaceState);
exports.getProducts = getProducts;
var getProductsPagination = R.compose(R.prop('pagination'), getMarketplaceState);
exports.getProductsPagination = getProductsPagination;
var getCurrentMarketplacePage = (0, _reselect.createSelector)(getProductsPagination, R.compose( // eslint-disable-next-line no-underscore-dangle
R.or(R.__, 0), Number, R.prop('current_page')));
exports.getCurrentMarketplacePage = getCurrentMarketplacePage;
var getMarketplaceIsLoading = R.compose(R.prop('isLoading'), getMarketplaceState);
exports.getMarketplaceIsLoading = getMarketplaceIsLoading;
var getMarketplaceExchangeIsLoading = R.compose(R.prop('exchangeLoading'), getMarketplaceState);
exports.getMarketplaceExchangeIsLoading = getMarketplaceExchangeIsLoading;
var getMarketplaceExchangeDenomination = R.compose(R.prop('rangeDenominationValue'), getMarketplaceState);
exports.getMarketplaceExchangeDenomination = getMarketplaceExchangeDenomination;
var getMarketplaceConvertedPrice = R.compose(R.prop('convertedPrice'), getMarketplaceState);
exports.getMarketplaceConvertedPrice = getMarketplaceConvertedPrice;
var getMarketplaceConvertedPrices = R.compose(R.prop('convertedPrices'), getMarketplaceState);
exports.getMarketplaceConvertedPrices = getMarketplaceConvertedPrices;
var getFilters = R.compose(R.prop('filters'), getMarketplaceState);
exports.getFilters = getFilters;
var getMarketplaceCountryId = R.pathOr(null, ['createGift', 'marketplace', 'countryId']);
exports.getMarketplaceCountryId = getMarketplaceCountryId;

var getProductById = function getProductById(id) {
  return function (state) {
    return R.compose(R.find(function (product) {
      return product.id === id;
    }), getProducts)(state);
  };
};

exports.getProductById = getProductById;